import { useMount } from 'react-use';

import { areSystemNotificationsEnabled } from '.';
import toast from '../../toasts/toasts';
import { SystemNotificationsPermissionSoftPromptWrapper } from './SystemNotificationsPermissionSoftPromptWrapper';
import { SYSTEM_NOTIFICATIONS_PERMISSION_USER_GESTURE_PROMPT_TOAST_KEY } from './constants';
import { useRequestNotificationPermissionCallback } from './useRequestNotificationPermissionCallback';

/**
 * Request system notification permissions on mount. If the user has not yet
 * granted or denied permission, this will trigger the browser's native
 * permission prompt. If the user has already granted or denied permission, this
 * will do nothing. If the browser requires a user gesture to request permission
 * (e.g. Safari), this will show a toast prompting the user to click a button to
 * request permission.
 */
export function useRequestSystemNotificationPermission() {
  const requestNotificationPermission = useRequestNotificationPermissionCallback();

  useMount(function handleRequestingSystemNotificationPermissions() {
    if (!areSystemNotificationsEnabled()) {
      return;
    }

    requestNotificationPermission().then((permissionRequestionResult) => {
      if (permissionRequestionResult === 'user-gesture-required') {
        toast.enqueue(SystemNotificationsPermissionSoftPromptWrapper, {
          key: SYSTEM_NOTIFICATIONS_PERMISSION_USER_GESTURE_PROMPT_TOAST_KEY,
          purpose: 'system',
          timeout: Infinity,
        });
      }
    });
  });
}
